const TOKEN_LOCALSTORAGE_KEY = 'TOKEN';

export const getToken = () => {
  const token = document?.cookie?.split('; ')?.find(s => s.startsWith('__Secure-SID'))?.split('=')?.pop();
  if (token) {
    setToken(token);
    return token;
  } else {
    setToken(null);
    return null;
  }
};

export const setToken = (token) => window.localStorage.setItem(TOKEN_LOCALSTORAGE_KEY, token);
